<template>
  <div class="chart" ref="lineChart"></div>
</template>

<script>
import echarts from 'echarts';
import ChartFunctionHelper from '@/helpers/chartFunctionHelper';
import FuncHelper from '@/helpers/funcHelper';

export default {
  name: 'homeNewsDistributeChart',
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      chart: null
    };
  },
  methods: {
    chartOption() {
      const option = {
        legend: {
          orient: 'vertical',
          bottom: '10%',
          selectedMode: false,
          data: this.data.series,
          formatter: (name) => {
            const data = this.data.series;
            let value;
            for (let i = 0, l = data.length; i < l; i++) {
              if (data[i].name === name) {
                value = data[i].value;
              }
            }
            return `${name}             ${value}`;
          },
          textStyle: {
            color: '#fff'
          }
        },
        series: [
          {
            name: '数据',
            type: 'pie',
            radius: ['33%', '50%'],
            center: ['50%', '28%'],
            label: {
              normal: {
                show: true,
                position: 'outside'
              },
              emphasis: {
                show: true,
                textStyle: {
                  fontSize: '14',
                  fontWeight: 'bold'
                }
              }
            },
            labelLine: {
              show: true,
              length: 8,
              length2: 8
            },
            itemStyle: {
              borderWidth: 1,
              borderColor: '#3e3c42'
            },
            data: this.data.series
          }
        ]
      };
      return option;
    },
    generateChart() {
      const lineChart = echarts.init(this.$refs.lineChart);
      const option = this.chartOption();
      lineChart.on('mouseover', (params) => {
        this.$emit('change', { 
          value: params.value, 
          name: params.name, 
          percent: params.percent, 
          color: params.color[0] 
        });
      });
      lineChart.on('mouseout', () => {
        this.$emit('change', { value: 0 });
      });
      lineChart.setOption(option);
      ChartFunctionHelper.preventLastSeriesUnseleted(lineChart);
      return lineChart;
    },
    resize() {
      if (this.chart) {
        FuncHelper.debounce(this.chart.resize, 300)();
      }
    }
  },
  mounted() {
    window.addEventListener('resize', this.resize);
    this.chart = this.generateChart();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resize);
    if (this.chart) {
      this.chart.dispose();
    }

    if (this.chart) {
      this.chart.off('finished');
    }
  }
};
</script>

<style lang="scss" scoped>
.chart{
  width:100%;
  height: 100%;
}
</style>
